export default "__VITE_ASSET__BqCR$rXj__"